import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { DEVICE_TAGS_QUERY_KEY } from '../constants/query';
import TagService from '../services/tag.service';
import useSubscribeStorage from '../hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';

const useFetchDeviceTags = ({ debouncedSearchValue, enabled }) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const { data, ...props } = useQuery(
    [DEVICE_TAGS_QUERY_KEY, customerEnvId, debouncedSearchValue],
    () => TagService.getTags({ customerEnvId, search: debouncedSearchValue }),
    {
      enabled: enabled && !!customerEnvId,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );

  const tags = useMemo(() => data?.tags || [], [data?.tags]);
  const fetchedData = useMemo(() => ({ data: tags, count: data?.count || 0 }), [tags, data?.count]);

  return {
    ...props,
    tags,
    fetchedData,
  };
};

export default useFetchDeviceTags;
